import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private authService: AuthService,private router:Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this.authService.getUser()
    if (user) {
      // logged in so return true
      this.authService.currentUser.next(user)
      this.authService.loadPermissions(user)
      return true;
    }
    this.router.navigate(['/auth','login'])
    // not logged in so redirect to login page with the return url
    return false;
  }
}
